"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MY_PLACES_PROXIMITY_CONFIG_FIELD_DESCRIPTIONS = exports.MY_PLACES_PROXIMITY_CONFIG_FIELD_LABELS = exports.MY_PLACES_PROXIMITY_ROLLOUT_MODE_LABELS = exports.MAX_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES = exports.MIN_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES = exports.MAX_MY_PLACES_PROXIMITY_RADIUS_METERS = exports.MIN_MY_PLACES_PROXIMITY_RADIUS_METERS = exports.DEFAULT_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES = exports.DEFAULT_MY_PLACES_PROXIMITY_RADIUS_METERS = exports.DEFAULT_MY_PLACES_PROXIMITY_ROLLOUT_MODE = void 0;
exports.buildDefaultMyPlacesProximityConfig = buildDefaultMyPlacesProximityConfig;
exports.parseMyPlacesProximityConfig = parseMyPlacesProximityConfig;
exports.validateMyPlacesProximityConfigForSave = validateMyPlacesProximityConfigForSave;
const enums_1 = require("../enums");
exports.DEFAULT_MY_PLACES_PROXIMITY_ROLLOUT_MODE = enums_1.MyPlacesProximityRolloutMode.Disabled;
exports.DEFAULT_MY_PLACES_PROXIMITY_RADIUS_METERS = 250;
exports.DEFAULT_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES = 240;
exports.MIN_MY_PLACES_PROXIMITY_RADIUS_METERS = 50;
exports.MAX_MY_PLACES_PROXIMITY_RADIUS_METERS = 2000;
exports.MIN_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES = 5;
exports.MAX_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES = 24 * 60;
exports.MY_PLACES_PROXIMITY_ROLLOUT_MODE_LABELS = {
  [enums_1.MyPlacesProximityRolloutMode.Disabled]: 'Disabled',
  [enums_1.MyPlacesProximityRolloutMode.InternalOnly]: 'Internal users only',
  [enums_1.MyPlacesProximityRolloutMode.All]: 'All users'
};
exports.MY_PLACES_PROXIMITY_CONFIG_FIELD_LABELS = {
  radiusMeters: 'Detection radius (meters)',
  cooldownMinutes: 'Cooldown per venue (minutes)'
};
exports.MY_PLACES_PROXIMITY_CONFIG_FIELD_DESCRIPTIONS = {
  radiusMeters: 'How close a user must be to one of their My Places to trigger a nearby notification.',
  cooldownMinutes: 'Minimum time before the same user can be notified again about the same venue.'
};
function buildDefaultMyPlacesProximityConfig() {
  return {
    rolloutMode: exports.DEFAULT_MY_PLACES_PROXIMITY_ROLLOUT_MODE,
    radiusMeters: exports.DEFAULT_MY_PLACES_PROXIMITY_RADIUS_METERS,
    cooldownMinutes: exports.DEFAULT_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES
  };
}
function parseIntInRange(value, fallback, min, max) {
  if (typeof value === 'number' && Number.isFinite(value) && Number.isInteger(value) && value >= min && value <= max) {
    return value;
  }
  return fallback;
}
function parseRolloutMode(value, fallback) {
  if (typeof value === 'string' && Object.values(enums_1.MyPlacesProximityRolloutMode).includes(value)) {
    return value;
  }
  return fallback;
}
function parseMyPlacesProximityConfig(raw) {
  const defaults = buildDefaultMyPlacesProximityConfig();
  if (!raw || typeof raw !== 'object') {
    return defaults;
  }
  const value = raw;
  return {
    rolloutMode: parseRolloutMode(value.rolloutMode, defaults.rolloutMode),
    radiusMeters: parseIntInRange(value.radiusMeters, defaults.radiusMeters, exports.MIN_MY_PLACES_PROXIMITY_RADIUS_METERS, exports.MAX_MY_PLACES_PROXIMITY_RADIUS_METERS),
    cooldownMinutes: parseIntInRange(value.cooldownMinutes, defaults.cooldownMinutes, exports.MIN_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES, exports.MAX_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES)
  };
}
function validateMyPlacesProximityConfigForSave(value) {
  var _ref, _checkIntRange;
  if (!value || typeof value !== 'object') {
    return {
      message: 'myPlacesProximity config must be an object.'
    };
  }
  const config = value;
  if (typeof config.rolloutMode !== 'string' || !Object.values(enums_1.MyPlacesProximityRolloutMode).includes(config.rolloutMode)) {
    return {
      message: 'myPlacesProximity.rolloutMode must be one of disabled/internal_only/all.'
    };
  }
  const checkIntRange = (key, min, max) => {
    const raw = config[key];
    if (typeof raw !== 'number' || !Number.isInteger(raw)) {
      return {
        message: "myPlacesProximity.".concat(key, " must be an integer.")
      };
    }
    if (raw < min || raw > max) {
      return {
        message: "myPlacesProximity.".concat(key, " must be between ").concat(min, " and ").concat(max, ".")
      };
    }
    return null;
  };
  return (_ref = (_checkIntRange = checkIntRange('radiusMeters', exports.MIN_MY_PLACES_PROXIMITY_RADIUS_METERS, exports.MAX_MY_PLACES_PROXIMITY_RADIUS_METERS)) !== null && _checkIntRange !== void 0 ? _checkIntRange : checkIntRange('cooldownMinutes', exports.MIN_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES, exports.MAX_MY_PLACES_PROXIMITY_COOLDOWN_MINUTES)) !== null && _ref !== void 0 ? _ref : null;
}
//# sourceMappingURL=my-places-proximity-config.js.map